import React from 'react';
import TerminalChat from './TerminalChat';

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <span className="badge" style={{ marginBottom: 14 }}>
            <span className="wave" role="img" aria-label="waving hand">👋</span> Welcome
          </span>
          <h1>
            <span className="grad">Shubhajeet Pradhan</span> — AI/Software Engineer
            <span className="type-cursor" aria-hidden="true">▮</span>
          </h1>
          <p>
            Integrated B.Tech–M.Tech (IT) at IIIT Gwalior (2025). Software Engineer at Mindtickle and Post Graduated from Indian Institution of Information Technology, Gwalior.
          </p>
          <div className="hero-ctas">
            <a className="btn btn-primary" href="#projects">View projects</a>
          </div>
        </div>
        <div>
          <TerminalChat />
        </div>
      </div>
    </section>
  );
}
